export default __webpack_public_path__ + "static/media/bgImage.a569568e.png";